import { render, staticRenderFns } from "./BasketballCover_c2.vue?vue&type=template&id=a8441660&"
import script from "./BasketballCover_c2.vue?vue&type=script&lang=js&"
export * from "./BasketballCover_c2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports